import { useStorage } from "app/custom-hooks/storage/useStorage";
import AdIntelligenceUpgradeBanner from "app/pages/sales-intelligence/common-components/feature-upgrade/AdIntelligenceUpgradeBanner";
import { leadsSearchSessionStorage } from "app/pages/sales-intelligence/modules/leads-search/services/storage";

export const AdSpendChannelsUpgradeView = () => {
    const [isSubmitted, setSubmitted] = useStorage<boolean>(
        leadsSearchSessionStorage.adSpendChannelsFilterHookSubmitted,
    );

    return (
        <AdIntelligenceUpgradeBanner
            isSubmitted={isSubmitted}
            variant="ad_spend_channels_filter"
            onSubmit={() => setSubmitted(true)}
        />
    );
};
